import type { BadgeVariantProps } from "@/ui2/atoms/Badge";
import { CosignatureStatus, CosignatureStatusParam } from "@/core/types";
import { CosignatureStatusEnum } from "@/core/constants";

import { CosignatureTab } from "../types";

export const CosignatureTabEnum = {
  ALL_NOTES: "all-notes",
  NEEDS_REVIEW: "needs-review",
} as const;

export const ALL_OPTION_ID = "all";

export const TAB_DEFAULT_COSIGNATURE_STATUS: Record<CosignatureTab, CosignatureStatusParam> = {
  "all-notes": "",
  "needs-review": [CosignatureStatusEnum.PENDING, CosignatureStatusEnum.RESUBMITTED].join(
    ",",
  ) as CosignatureStatusParam,
};

type StatusVariant = Pick<BadgeVariantProps, "appearance" | "variant">;

export const STATUS_VARIANT: Record<CosignatureStatus, StatusVariant> = {
  pending: { appearance: "outline", variant: "neutral" },
  rejected: { appearance: "outline", variant: "error" },
  resubmitted: { appearance: "outline", variant: "warning" },
  signed: { appearance: "outline", variant: "success" },
} as const;
